import {flow, getEnv, types} from "mobx-state-tree";
import {RuleSetsStore} from "../stores/domain/RuleSetsStore";
import lodash from "lodash";

export const RuleSetsListModel = types.model({
  store:types.maybe(types.late(() => types.reference(RuleSetsStore))),
  isLoading: types.optional(types.boolean, false), //types.enumeration('State', ['pending', 'done', 'error']),
  page: types.optional(types.integer, 1),
  perPage: types.optional(types.integer, 10),
  totalRows: types.optional(types.integer, 0),
  sortOrder: types.optional(types.string, "desc"),
  sortField:  types.optional(types.string, "updatedAt"),
}).volatile(self => ({
  searchParams: {},
  filters: {}
})).actions((self) => ({
  fetchAll: flow(function* fetchAll(sortParams = {}) {
    self.isLoading = true
    try {
      let queryParams = {
        page: self.page,
        perPage: self.perPage,
        ...sortParams,
        ...self.searchParams
      }

      //if its not a group query add isExclusivelyGroupOwned
      queryParams = Object.assign({
          ...queryParams,
        },
        lodash.isEmpty(queryParams.groupUuid) && {isExclusivelyGroupOwned: false}
      )

      const manager = getEnv(self).ruleSetManager
      console.log("queryParams in fetchAll ruleSets", queryParams)
      const response = yield manager.fetchAll(queryParams);
      if (response != null) {
        console.log("response.results", response.results);
        self.store?.setRuleSets(response?.results)
        self.totalRows = response._meta.itemCount;
        self.isLoading = false;
      } else {
        self.isLoading = false;
      }
    } catch (error) {
      console.error('Failed to fetch ruleSets', error)
    }
  }),
  fetchFilters: flow(function* fetchFilters(sortParams = {}) {
    self.isLoading = true;

    try {
      const queryParams = {
        ...self.searchParams
      }

      const ruleSetManager = getEnv(self).ruleSetManager
      const response = yield ruleSetManager.fetchFilters(queryParams);
      if (response != null) {
        self.filters = response
        self.isLoading = false;
      } else {
        self.isLoading = false;
      }

    } catch (error) {
      console.error('Failed to fetch all', error)
    }
  }),
  setSortOrder(sortDirection){
    self.sortOrder = sortDirection
  },
  setSortField(sortField){
    self.sortField = sortField
  },
  updatePage: function (page) {
    self.page = page
  },
  updatePerPage: function (perPage) {
    self.perPage = perPage
  },
  addSearchParams(param){
    self.searchParams = {...self.searchParams, ...param}
    self.store.addSearchParams(self.searchParams)
  },
  removeSearchParams(names,regex = ''){
    if(names){
      names.map((name) => delete self.searchParams[name])
    }
    if(regex){
      const keysToDelete = Object.keys(self.searchParams).filter(key => regex.test(key));
      keysToDelete.forEach(key => delete self.searchParams[key]);
    }
    self.store.clearSearchParams(names,regex)
  },
})).views( (self) => ({
  getItems() {
    const { flatList } = self.store || {};
    return flatList || []
  },
  getSearchParams() {
    return self.searchParams;
  }
}))
